import React from 'react';
import { Container, Message, List } from 'semantic-ui-react';
import { INSTRUCTIONS_HEADER, INSTRUCTIONS_STEPS } from '../../constants/forceGuarantee';

// Static onboarding copy for the page, rendered until the first search is
// performed. Holds no state and takes no props, so the page component keeps
// only the flow logic.
function ForceGuaranteeInstructions() {
  return (
    <Container fluid>
      <Message>
        <Message.Header>{INSTRUCTIONS_HEADER}</Message.Header>
        <List ordered>
          {INSTRUCTIONS_STEPS.map(step => (
            <List.Item key={step}>{step}</List.Item>
          ))}
        </List>
      </Message>
    </Container>
  );
}

export default ForceGuaranteeInstructions;
